






import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { IIssue } from '@/lib/interfaces';
import { EIssueStatus } from '@/lib/enums';
import { getMyIssues } from '@/services/api.service';
import Trello from '@/components/Trello.vue';
import { pushOrDeleteIssue } from '@/lib/helpers/issue.helper';

@Component({
  components: {
    Trello,
  },
  sockets: {
    issueUpdated(this: ActualIssues, newIssue: IIssue) {
      pushOrDeleteIssue(this.issues, newIssue, newIssue.status !== EIssueStatus.Done);
    },
  },
})
export default class ActualIssues extends Vue {
  private issues: IIssue[] = [];
  private statuses: EIssueStatus[] = Object.values(EIssueStatus).filter((el) => el !== EIssueStatus.Done);

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const status = Object.values(EIssueStatus).filter((el) => el !== EIssueStatus.Done);
    const issues: IIssue[] = await getMyIssues({ status, actual: true, deleted: false });
    next((vm: ActualIssues) => {
      vm.issues = issues;
    });
  }
}
